"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconsWrapper = exports.FooterContainer = exports.Footer = exports.DividerWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyle__Footer",
  componentId: "sc-84mwo6-0"
})(function (props) {
  return (0, _styledComponents.css)(["background-color:", ";", ""], props.footerTheme.appearance[props.appearance].backgroundColor, (0, _coreMixins.advancedSpacing)('padding', [4, 6]));
});

exports.Footer = Footer;

var FooterContainer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyle__FooterContainer",
  componentId: "sc-84mwo6-1"
})(function (props) {
  return (0, _styledComponents.css)(["max-width:", "px;margin:auto;"], props.theme.gridConfig.springWidth);
});

exports.FooterContainer = FooterContainer;

var IconsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyle__IconsWrapper",
  componentId: "sc-84mwo6-2"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:space-between;align-items:center;", ""], (0, _coreMixins.spacing)('margin-bottom', 6));
});

exports.IconsWrapper = IconsWrapper;

var DividerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyle__DividerWrapper",
  componentId: "sc-84mwo6-3"
})(function () {
  return (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-bottom', 4));
});

exports.DividerWrapper = DividerWrapper;
//# sourceMappingURL=Footer.style.js.map